import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../shared/model/user.service";
import {User} from "../shared/model/user";
import {AuthService} from "../shared/security/auth.service";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css']
})
export class UserInfoComponent implements OnInit, OnChanges {
  myForm: FormGroup;

  name: string;
  email: string;
  phone: string;
  role: string;
  isSaved: boolean = false;

  public visible = false;
  private user: User;

  private confirmationTitle: string;
  private confirmationText: string;
  public inDeleteMode: boolean;

  public roles = [
    { value: 'superadmin', display: 'Superadmin'},
    { value: 'admin', display: 'Admin'},
    { value: 'steward', display: 'Steward'},
    { value: 'trainer', display: 'Trainer'},
    { value: 'player', display: 'Player'}
  ];

  constructor(private fb: FormBuilder, private userService: UserService, private authService: AuthService, private translate: TranslateService, private router: Router) {
    this.myForm = fb.group({
      'name': ['', Validators.required],
      'phone': ['', Validators.required],
      'email': [{value: '', disabled: true}],
      'role': [{value: '', disabled: true}]
    });
  }

  ngOnInit() {
    this.user = this.authService.getCurrentUser();
    this.name = this.user.name;
    this.email = this.user.email;
    this.phone = this.user.phone;
    this.role = this.user.role;
  }

  signUp() {
  }

  delete() {
    let userId = this.user.$key;

    this.translate.get('l.deleteaccount').subscribe((res: string) => {
      this.confirmationTitle = res;
      this.translate.get('l.deleteaccountmsg').subscribe((res2: string) => {
        this.confirmationText = res2;
        this.inDeleteMode = true;
      });
    });
  }

  ngOnChanges() {
    if(this.user) {
      this.name = this.user.name;
      this.phone = this.user.phone;
    }
  }

  public hide(): void {
    this.router.navigate(['home']);
  }

  public close(): void {
    this.router.navigate(['home']);
  }

  public save(): void {
    var isChanged: boolean = false;
    var changedElements = {
      "name": this.user.name === this.name? this.user.name: (isChanged = true, this.name),
      "phone": this.user.phone === this.phone? this.user.phone: (isChanged = true, this.phone),
    };

    if(isChanged) {
      this.userService.updateUser(this.user.$key, changedElements);
    }

    this.isSaved = true;
  }

  processConfirmation(result: boolean) {
    if(result) {
      console.log('deleting user: ' + this.user.$key);
      this.userService.deleteUser(this.user.$key);
      this.translate.get('s.deleteaccount').subscribe((res: string) => {
        this.router.navigate(['home']);
        this.authService.logout();
        alert(res);
      });
    }
    this.inDeleteMode = false;
  }
}
